import { isFinanceProject, isGlobalProject } from 'config';
import { applySchema } from 'helpers';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  object,
} from 'libs/form';
import { TFunc } from 'libs/i18n';
import {
  AdditionalDocumentsFormType,
  getAdditionalDocumentsSchema,
} from 'modules/client/common/forms/additionalDocumentsForm';
import {
  placeOfBirthSchema,
  PlaceOfBirthFormType,
} from 'modules/client/common/forms/placeOfBirthForm';
import {
  ReasonChangeFormType,
  reasonChangeSchema,
} from 'modules/client/common/forms/reasonChangeForm';

import { BaseActivityFormType, baseActivitySchema } from './baseActivityForm';
import { CitizenshipFormType, citizenshipsSchema } from './citizenshipForm';
import { ContactsFormType, getContactsSchema } from './contactsForm';
import {
  IdentityDocumentFormType,
  identityDocumentSchema,
} from './identityDocumentForm';
import {
  LegalClientHeadPositionFormType,
  getLegalClientHeadPositionFormSchema,
} from './legalClientHeadInfoForm';
import {
  PepConnectionFormType,
  getPepConnectionSchema,
} from './pepConnectionForm';
import {
  PersonalDataFormType,
  getPersonalDataSchema,
} from './personalDataForm';
import {
  RegistrationAddressFormType,
  registrationAddressSchema,
} from './registrationAddressForm';
import {
  ResidentialAddressFormType,
  residentialAddressWithFilesSchema,
} from './residentialAddressForm';
import {
  TaxResidencyFormType,
  getTaxResidencesSchema,
} from './taxResidencyForm';

export interface LegalClientHeadFormType
  extends BaseActivityFormType,
    ContactsFormType,
    LegalClientHeadPositionFormType,
    PersonalDataFormType,
    CitizenshipFormType,
    TaxResidencyFormType,
    RegistrationAddressFormType,
    ResidentialAddressFormType,
    IdentityDocumentFormType,
    PepConnectionFormType,
    AdditionalDocumentsFormType,
    PlaceOfBirthFormType,
    ReasonChangeFormType {}

export const getSchema = (t: TFunc): ObjectSchema<LegalClientHeadFormType> => {
  const isGlobal = isGlobalProject();
  const isFinance = isFinanceProject();
  return object()
    .concat(getContactsSchema(t))
    .concat(getPersonalDataSchema(t))
    .concat(citizenshipsSchema)
    .concat(baseActivitySchema)
    .concat(getTaxResidencesSchema())
    .concat(applySchema(isFinance, registrationAddressSchema))
    .concat(applySchema(isGlobal, placeOfBirthSchema))
    .concat(residentialAddressWithFilesSchema)
    .concat(getLegalClientHeadPositionFormSchema(t))
    .concat(identityDocumentSchema)
    .concat(getPepConnectionSchema(t, { notRequestInformation: isGlobal }))
    .concat(reasonChangeSchema)
    .concat(getAdditionalDocumentsSchema());
};

export const { Field, Form, useFormContext, Submit } =
  TypedForm<LegalClientHeadFormType>();

export type FormErrors = FormErrorsBase<LegalClientHeadFormType>;
